<template>
  <vz-row v-for="i in count" :key="i">
    <vz-col>
      <vz-skeleton type="rounded" height="50" class="w-50"/>
    </vz-col>
    <vz-col v-for="k in 7" :key="k" class="color-dark text-medium">
      <vz-skeleton type="rounded" height="20" class="mb-10" />
      <vz-skeleton type="rounded" height="30" />
    </vz-col>
  </vz-row>
</template>

<script setup lang="ts">
const props = defineProps({
  isDispatch: {
    type: Boolean,
    default: false
  }
})

const count = computed(() => {
  return props.isDispatch ? 1 : 3
})
</script>